import { render } from "./DashboardFolders.vue?vue&type=template&id=aa0f6150"
import script from "./DashboardFolders.vue?vue&type=script&lang=js"
export * from "./DashboardFolders.vue?vue&type=script&lang=js"

import "./DashboardFolders.vue?vue&type=style&index=0&id=aa0f6150&setup=true&lang=css"

import exportComponent from "C:\\creatorcube-vue3\\CreatorCUBE\\CreatorCUBE_Controller\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__